/** sessionStorage key for referral code captured from ?ref= before signup */
export const PENDING_REFERRAL_STORAGE_KEY = 'mythkit_pending_referral';
